export default "__VITE_ASSET__67d1c461__"